<template>
  <section class="oldProduct">
    <el-card class="box-card">
      <div slot="header"
           class="clearfix">
        <span class="header-title">添加旧机</span>
        <el-button v-if="assess&&assess.goodsId"
                   style="float: right; padding: 3px 0"
                   type="text"
                   @click="clearProduct()"><i class="el-icon-delete"
             style="font-size:24px;"></i></el-button>
      </div>

      <div class="box-content"
           v-if="assess&&assess.goodsId">
        <div class="contentLeft">
          <div class="image"
               :style="'background:url('+assess.goodsImg+') no-repeat;background-size:100%;'"></div>
          <div class="name">{{assess.goodsName}}</div>
          <div class="contentBtn">
            <a href="javascript:;"
               @click="clickReturnAttr">重新评估</a>
          </div>
        </div>
        <div class="contentRight">
          <div class="price">
            旧机报价
            <span v-if="assess.assessAmount">
              <em>¥</em>{{assess.assessAmount}}
            </span>
          </div>
          <div class="attrs">
            <span v-for="item in assess.assessUserAttr.split(',')"
                  :key="item">{{item}}</span>
          </div>
        </div>
      </div>
      <div class="box-content addProduct"
           v-else>
        <el-button round
                   @click="clickDialogVisible()">添加旧机</el-button>
      </div>
      <el-dialog title="旧机评估"
                 :visible.sync="user.dialogVisibleValue"
                 class="content-dialog">
        <Evaluate @setProduct="setProduct" />
      </el-dialog>
      <el-dialog title="评估选项"
                 :visible.sync="dialogVisibleAttr"
                 class="content-dialog">
        <Attr :total="total" />
      </el-dialog>
    </el-card>
  </section>
</template>

<script>
import Evaluate from "../../../components/PC/Product/Evaluate"
import Attr from "../../../components/PC/Product/Attr"
export default {
  props: ["assess"],
  data () {
    return {
      dialogVisibleAttr: false,
      total: 1
    }
  },
  computed: {
    user () {
      return this.$store.state.user;
    },
  },
  components: {
    Evaluate,
    Attr
  },
  inject: ["reload"],
  methods: {
    dialogVisible () {

    },
    clickDialogVisible () {
      this.$store.commit('user/setVisibleValue');
      // this.dialogVisibleValue = !this.dialogVisibleValue;
    },
    setProduct (value) {
      // this.product = value
      this.total = this.$store.state.oldproduct.product.attrValue.length
      // this.dialogVisibleValue = !this.dialogVisibleValue;
      this.dialogVisibleAttr = !this.dialogVisibleAttr;
    },
    clickReturnAttr () {
      this.dialogVisibleValue = !this.dialogVisibleValue;
    },
    clearProduct () {
      localStorage.assess = "";
      this.$store.commit('assess/setAssessData', { data: { assessAmount: 0 } });
      location.reload();
      // this.reload();
    }
  }
};
</script>

<style scoped>
.oldProduct {
  margin-top: 10px;
}
.box-content {
  display: flex;
}
.header-title {
  float: left;
  margin-top: 5px;
  font-weight: bold;
  font-size: 20px;
}
.contentLeft {
  text-align: center;
  width: 200px;
}
.contentLeft .image {
  width: 100px;
  height: 100px;
  background: url(https://image.suhuishou.com/attached/image/20181120/20181120171959_48005.jpg)
    center center no-repeat;
  background-size: 100%;
  display: inline-block;
}
.contentLeft .name {
  margin: 20px 0;
}
.contentLeft .contentBtn a {
  display: inline-block;
  border-radius: 50px;
  border: #efefef solid 1px;
  padding: 5px 20px;
}
.contentRight {
  width: 500px;
}
.contentRight .price span {
  margin-left: 20px;
  font-size: 24px;
  color: #e60012;
}
.contentRight .price span em {
  font-style: normal;
  font-size: 16px;
}
.contentRight .attrs {
  margin-top: 20px;
}
.contentRight .attrs span {
  display: inline-block;
  border-radius: 50px;
  border: #efefef solid 1px;
  padding: 5px 20px;
  margin: 15px 10px 0 0;
  color: #666;
}
.addProduct button {
  display: block;
  margin: 0 auto;
}
</style>
